import AXIOS from "./axios";

export class Documents {
  // Receitas, exames e atestados do paciente logado em uma lista única.
  // Sem type, devolve todos; com type, só os daquele tipo.
  // Sem page, devolve a lista inteira; com page, 10 por página.
  // Resposta: { total_count, documents }.
  static fetchPatientDocuments(type, page) {
    const params = {};
    if (type) params.type = type;
    if (page) params.page = page;
    return AXIOS.get("/documents", { params });
  }
}
